<template>
  <tabs :tabs="tabsFiltered" :entity-type="entityType" :entity-id="entityId" />
</template>

<script>
import jwtDecode from 'jwt-decode';
import { mapState } from 'vuex';

import Tabs from '@/components/tabs/Tabs';
import { TableName } from '@/enums/tableName';

// @vuese
// Profil
// @group Profile
export default {
  components: { Tabs },
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      entityType: TableName.profile
    };
  },
  computed: {
    ...mapState({
      isSsoUser: state => !jwtDecode(state.auth.token).user.login.includes('@'),
      entityId: state => state.profile.data.id.toString()
    }),
    tabsFiltered() {
      if (!this.isSsoUser) {
        return this.tabs;
      }
      return this.tabs.filter(tab => tab.title !== 'Edycja');
    }
  }
};
</script>
